<template>
  <b-col md="12" xl="6">
    <section class="codes-refer">
      <p class="codes-refer__title">Codici e Riferimenti</p>
      <div class="codes-refer__info">
        <p>N°prenotazione Booking.com: <strong>{{ confirm.bookingVoucher.reservation_id }}</strong></p>
        <p>Codice di conferma: <strong>{{ confirm.bookingVoucher.confirmcode }}</strong></p>
        <p>Persona di riferimento: <strong>{{ confirm.bookingVoucher.displayName }}</strong></p>
        <p>Email: <strong>{{ confirm.bookingVoucher.email }}</strong></p>
      </div>
    </section>
  </b-col>
</template>

<script>

export default {
  name: 'codes-references',

  components: {
  },

  props: {
    confirm: Object
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .codes-refer {
    background-color: #fafcff;
    border-radius: 10px;
    padding: 15px 20px;
    border: 1px solid $gray-300;
    height: 100%;

    @media print {
      border: none;
      padding: 0;
      background-color: $white;
      margin-bottom: $grid-gutter-width*2;
    }

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 10px;
    }

    &__info {
      p {
        margin-bottom: 5px;
      }
      strong {
        font-weight: $vb-font-weight-semibold;
      }
    }
  }

</style>